module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVHgB7ZFRDYAwDEQbgoBJmANwABKQgJQ6wAKScIAEJIwuDDKadeu++OGS++h2l/dxAJ/JAUzkg+zIi6ZgyHso3J55rmF3T7bsbSiVVPpLQS3tMEZ3l8gYltn8oCsbM2c/vPUlW1HCh6ekXZSoZKsoStqboqQhSBJoaUqBhlASo+UpAg1Bq0DTURgNpf8TzA64IqddIRYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gamecompetition/down.png
// module id = 2SkK
// module chunks = 0